'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _enUS = require('./icons/en-US');

var _enUS2 = _interopRequireDefault(_enUS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {מסננים}\n  =1 {מסנן\n  ' + 'other {# מסננים}\n}'
  }
}, _enUS2.default, {
  Active: 'פעיל',
  Activate: 'הפעל',
  Activated: 'מופעל',
  Add: 'הוסף',
  add: 'הוסף',
  Alerts: 'התראות',
  All: 'הכל',
  ampm: 'ampm',
  Arc: 'קשת',
  AxisLabel: '{orientation} ציר',
  area: 'אזור',
  Bar: 'בר',
  bar: 'בר',
  Blank: 'ריק',
  Box: 'מסגרת',
  Carousel: 'קרוסלה',
  Category: 'קטגוריה',
  Circle: 'מעגל',
  Chart: 'תרשים',
  Children: 'ילדים',
  Clear: 'נקה טופס',
  Cleared: 'טופס נוקה',
  Close: 'סגור',
  'Close Menu': 'סגור תפריט',
  Completed: 'הושלם',
  'Connects With': 'מתחבר',
  created: 'נוצר',
  Critical: 'קריטי',
  'Currently Active': 'בחירה נוכחית',
  'Date Selector': 'בחירת תאריך',
  'Date Time Icon': 'פתח בחירת תאריך ושעה',
  day: 'יום',
  Disabled: 'לא פעיל',
  Distribution: 'הפצה',
  Email: 'דוא״ל',
  'Enter Select': 'הקש Enter לבחירה',
  Error: 'שגיאה',
  Filter: 'סנן',
  Footer: 'כותרת תחתונה',
  Grommet: 'Grommet',
  HotSpotsLabel: 'נקודות חמות: השתמש במקשי החצים לאינטרקציה',
  'GraphValues': 'הגרף מכיל {count} ערכים, הערך הגבוה הינו {highest}' + ' והנמוך הינו {smallest}',
  hour: 'שעה',
  'Grommet Logo': 'Grommet לוגו',
  'Layer': 'שכבה',
  List: 'רשימה',
  line: 'קו',
  'Loading': 'טוען',
  loginInvalidPassword: 'הכנס שם משתמש וסיסמא',
  'Log In': 'התחבר',
  Logout: 'התנתק',
  'Main Content': 'תוכן עיקרי',
  Max: 'מקסימלי',
  Menu: 'תפריט',
  Meter: 'מונה',
  Min: 'מינמאלי',
  minute: 'דקה',
  model: 'מודל',
  modified: 'שונה',
  monitor: 'ניטור',
  month: 'חודש',
  'Multi Select': 'בחירה מרובה',
  Name: 'שם',
  'Navigation Help': 'התשמש בחיצים לניווט',
  'Next Month': 'חודש הבא',
  'Next Slide': 'שקופית הבאה',
  'No Relationship': 'ללא קשר',
  'Notification': 'התראה',
  OK: 'אשר',
  Open: 'פתח',
  Parent: 'מקור',
  Parents: 'מקורות',
  Parts: 'חלקים',
  Part: 'חלק',
  Password: 'סיסמא',
  'Previous Month': 'חודש קודם',
  'Previous Slide': 'שקופית קודמת',
  'Previous Tiles': 'אריחים קודמים',
  'Remember me': 'זכור אותי',
  Resource: 'משאב',
  Running: 'הרצה',
  Search: 'חפש',
  'Match Results': '\u05D9\u05E9 {count, plural,\n      =0 {\u05E8\u05D9\u05E7}\n      one {\u05EA\u05D5\u05E6\u05D0\u05D4 \u05D0\u05D7\u05EA}\n      other {# \u05EA\u05D5\u05E6\u05D0\u05D5\u05EA}\n  }',
  second: 'שנייה',
  'Select Icon': 'פתח בחירה',
  Selected: 'נבחר',
  'Selected Multiple': '{count, plural,\n      =0 {\u05E8\u05D9\u05E7}\n      one {# \u05E2\u05E8\u05DA}\n      other {# \u05E2\u05E8\u05DB\u05D9\u05DD}\n  }',
  'Skip to': 'קופץ ל',
  'Slide Number': 'שקופית {slideNumber}',
  Sort: 'מיין',
  Spinning: 'מסתובב',
  Spiral: 'ספירלי',
  State: 'מצב',
  Status: 'סטטוס',
  Subtract: 'לחסר',
  SunBurst: 'תרשים עוגה',
  'Tab Contents': '{activeTitle} תוכן',
  Table: 'טבלה',
  Tasks: 'משימות',
  Tiles: 'אריחים',
  Time: 'שעה',
  Title: 'כותרת',
  Today: 'היום',
  Topology: 'טופולוגיה',
  Total: 'סה"כ',
  Threshold: 'סף',
  Unknown: 'לא ידוע',
  Username: 'שם משתמש',
  uri: 'URI',
  Value: 'ערך',
  Warning: 'אזהרה',
  year: 'שנה'
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/he.js
// module id = 201
// module chunks = 0